export default {
	title: 'Terminal Management',
	actions: {
		add: 'Add',
		edit: 'Edit',
		delete: 'Delete',
		batchDelete: 'Batch Delete'
	},
	messages: {
		deleteConfirm: 'Are you sure you want to delete the selected {count} records?',
		deleteSuccess: 'Operation successful',
		selectDeleteWarning: 'Please select records to delete',
		operateSuccess: 'Operation successful'
	},
	form: {
		projNo: 'Project',
		transferProtocol: 'Transfer Protocol',
		number: 'Terminal Number',
		typeId: 'Terminal Type',
		placeholder: {
			projNo: 'Please select project',
			transferProtocol: 'Please select transfer protocol',
			number: 'Please enter terminal number',
			typeId: 'Please select terminal type'
		}
	},
	table: {
		number: 'Terminal Number',
		projNo: 'Project No',
		orgId: 'Organization',
		model: 'Model',
		upMode: 'Up Mode',
		downMode: 'Down Mode',
		typeId: 'Terminal Type',
		transferProtocol: 'Transfer Protocol',
		ip: 'IP Address',
		maker: 'Maker',
		createTime: 'Create Time'
	},
	dialog: {
		add: 'Add',
		edit: 'Edit',
		cancel: 'Cancel',
		confirm: 'Confirm'
	},
	widgetForm: {
		projNo: 'Project',
		orgId: 'Organization',
		typeId: 'Terminal Type',
		maker: 'Maker',
		transferProtocol: 'Transfer Protocol',
		model: 'Model',
		number: 'Terminal Number',
		ip: 'IP Address',
		upMode: 'Up Mode',
		downMode: 'Down Mode',
		attachmentList: 'Network Link Diagram',
		gridLayout: 'Grid Layout',
		requiredFieldCannotBeEmpty: 'Required field cannot be empty',
		placeholder: {
			projNo: 'Please select project',
			orgId: 'Please select organization',
			typeId: 'Please select terminal type',
			maker: 'Please enter maker',
			transferProtocol: 'Please select transfer protocol',
			model: 'Please enter model',
			number: 'Please enter terminal number',
			ip: 'Please enter IP address',
			upMode: 'Please select up mode',
			downMode: 'Please select down mode'
		}
	}
}
